/* eslint-disable import/prefer-default-export */
import { CSSProperties } from 'react';

export const switchWrapper: CSSProperties = { padding: '23px' };
